const state = {
  firstMenu: [],
  twoMenu: '',
  cartList: [],
  token: '',
  member: null,
  regionMap: {},
  regions: [],
  location: [],
  code:''
};

export default state;
